import { Info } from "lucide-react";
import { Link } from "wouter";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

/**
 * Stands in for the retired Unit Of Measurement master page.
 */
const UnitOfMeasureRetired = () => (
  <div className="max-w-2xl">
    <h1 className="text-2xl font-bold mb-4">Unit Of Measurement</h1>
    <Card>
      <CardContent className="pt-6 space-y-4">
        <div className="flex gap-3">
          <Info className="h-5 w-5 shrink-0 text-blue-600 dark:text-blue-400" />
          <div className="space-y-2 text-sm">
            <p className="font-medium">
              This page is no longer needed — units now come from LHDN directly.
            </p>
            <p className="text-muted-foreground">
              Anywhere you enter a unit — on an item, an invoice line, a
              quotation, a sales or delivery order — you can search LHDN&rsquo;s
              full unit list by code or by name, and pick from it. There is no
              longer a separate list to set up first.
            </p>
            <p className="text-muted-foreground">
              Your existing units have not been deleted. They are simply no
              longer used, because a hand-entered code that LHDN does not
              publish causes the whole e-invoice to be rejected.
            </p>
          </div>
        </div>
        <Button asChild variant="outline">
          <Link href="/items">Go to Items</Link>
        </Button>
      </CardContent>
    </Card>
  </div>
);

export default UnitOfMeasureRetired;
